<template>
  <div class="item">
    <h4
      class="item_peson_num"
    >
      {{ price }}{{ $t('message["1524"]') }}
      <!-- <a-tag
        v-if="discount !== '0'"
        color="#42C27E"
        class="price_tag"
        v-text="discount"
      /> -->
    </h4>
    <!-- <p
      v-if="price !== 0"
      class="item_price"
    >
      {{ price }}元/人/年
    </p> -->
    <p
      class="item_contenet"
      v-text="content"
    />
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    price: {
      type: Number,
      default: 0
    },
    content: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.item {
  display: inline-block;
  min-width: 82px;
  height: 100%;
  margin-right: 80px;
  .item_peson_num {
    height: 24px;
    color: #333;
    font-weight: 600;
    line-height: 24px;
    .price_tag {
      height: 20px !important;
      padding: 0 3px !important;
    }
  }
  .item_price, .item_contenet {
    color: #b3b3b3;
  }
}
</style>
